import { GetItemCounts, SignatureType, useInfiniteSignatures } from '@ukpostbox/client-data';
import {
	ContentBlock,
	ContentLoader,
	FlexGap,
	InfiniteLoadTrigger,
	Modal,
	ModalSize,
	ModalType,
	StackHorizontal,
} from '@ukpostbox/frontend-framework';
import React, { useEffect, useState } from 'react';
import { useFrameworkStore } from '@ukpostbox/frontend-framework/lib/Providers/Stores/FrameworkStore';

function SelectSignatureForBatchModal(props: ModalType) {
	const { data, status, error, fetchNextPage, isFetchingNextPage, hasNextPage, isStale, isRefetching } =
		useInfiniteSignatures();

	const theme = useFrameworkStore((state) => state.theme);

	const [itemCounts, setItemCounts] = useState<any>({ loaded: 0, total: 0 });

	const HandleSignatureSelection = (signature: SignatureType) => {
		if (props.actionedCallback) {
			props.actionedCallback(signature);
			props.closeCallback();
		}
	};

	useEffect(() => {
		if (data) {
			setItemCounts(GetItemCounts(data as any));
		}
	}, [data]);

	return (
		<Modal
			title='Select Digital Signature'
			isOpen={props.isOpen}
			modalSize={ModalSize.Medium}
			closeCallback={props.closeCallback}
		>
			{status === 'pending' ? (
				<ContentLoader childHeight='6em' childCount={6} />
			) : status === 'error' ? (
				<ContentBlock error title={error.name} content={error.message} />
			) : (
				<>
					<StackHorizontal gap={FlexGap.Medium} wrap>
						{data.pages.map((group) =>
							group.data.map((signature, index) => {
								if (!signature.value) return null;
								return (
									<div
										key={`signature${signature.value}`}
										className='signature-entry'
										onClick={() => HandleSignatureSelection(signature)}
										onKeyDown={(e) =>
											e.code === 'Enter' ? HandleSignatureSelection(signature) : null
										}
										tabIndex={0}
										role='button'
									>
										<img
											src={signature.value}
											alt={`Signature ${index + 1}`}
											style={{ filter: theme === 'dark' ? 'invert(1)' : 'none' }}
										/>
									</div>
								);
							}),
						)}
					</StackHorizontal>

					{itemCounts.total > 0 && (
						<InfiniteLoadTrigger
							loaded={itemCounts.loaded}
							totalCount={itemCounts.total}
							hasNextPage={hasNextPage}
							fetchNextPage={fetchNextPage}
							isStale={isStale}
							isRefetching={isRefetching}
							isFetchingNextPage={isFetchingNextPage}
						/>
					)}
				</>
			)}
		</Modal>
	);
}

export { SelectSignatureForBatchModal };
